import React, { useEffect } from 'react'

import { TableHeader, TableBody/*, HorizontalScroll */ } from './Table'
import Navigator from './Navigator'

import './styles.scss'

/**
 * It renders a table with a header and a body
 * @param props - {
 * @param {array} colsToShow - name column thead
 * @param {[{key: string, value: string, isSelected: boolean}]} fieldsColumns - name columns config
 * @param {function} onChangeConfigHeader update cols order or show
 * @param {array} results results of search
 * @param {function} toggleOrder order asc o desc
 * @param {string} sortType type order asc | desc
 * @param {string} sortByField name column order
 * @param {function} onChangeMassiveAction apply action in result select
 * @param {number} limit value limit result Massive Actions
 * @param {number} totalResult value total result Massive Actions
 * @param {number} numberPage value number actual page pagination
 * @param {[{value:number, label:string}]} actionOptions list of options for mass actions
 * @param {function} onChangeAction Return selected massive action
 * @param {[{value:number, label:string}]} resultActionOptions list of options according to the selected action
 * @param {function} onChangeActionResultCheck check result
 * @param {function} detailResult view detail result
 * @param {[string]} checkResult list id check
 * @param {string} customClassNameContainer custom container className
 * @param {string} originType type of where the component is used
 * @param {boolean} isAllSelected all results have been selected?
 * @param {function} toggleSelectedAll handler to toggle result selection
 * @param {function} onApplyMassAction handler to apply massive action
 * @param {boolean} loadingMassiveAction Massive action button is loading
 * @param {boolean} resetMassiveAction Massive action data reset counter
 * @returns {React.ReactElement} A table with a header and a body.
 */
const SearchResult = (props) => {
  const {
    colsToShow, fieldsColumns, onChangeConfigHeader, results, checkResult,
    toggleOrder, sortType, sortByField, onChangeMassiveAction, detailResult,
    limit, totalResult, numberPage, actionOptions, onChangeAction,
    resultActionOptions, onChangeActionResultCheck, customClassNameContainer,
    originType = '', isAllSelected, toggleSelectedAll, onApplyMassAction,
    loadingMassiveAction, resetMassiveAction
  } = props
  // const [isVisibleHorizontalScroll, setIsVisibleHorizontalScroll] = useState(false)
  // const sliderHeader = document.getElementById('tableBookingHeader')
  // const sliderBody = document.getElementById('tableBookingBody')
  // const sliderHeaderCellsContainer = document.getElementById('tableBookingHeader__cells-container')
  // const SCROLL_OFFSET_VALUE = 100

  // useEffect(() => {
  //   if (sliderHeaderCellsContainer?.offsetWidth > sliderHeader?.offsetWidth) {
  //     setIsVisibleHorizontalScroll(true)
  //   } else {
  //     setIsVisibleHorizontalScroll(false)
  //   }
  // }, [sliderHeaderCellsContainer, colsToShow])

  useEffect(() => {
    isCheckAll()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkResult])

  // const slideLeft = () => {
  //   sliderHeader.scrollLeft = sliderHeader.scrollLeft - SCROLL_OFFSET_VALUE
  //   sliderBody.scrollLeft = sliderBody.scrollLeft - SCROLL_OFFSET_VALUE
  // }

  // const slideRight = () => {
  //   sliderHeader.scrollLeft = sliderHeader.scrollLeft + SCROLL_OFFSET_VALUE
  //   sliderBody.scrollLeft = sliderBody.scrollLeft + SCROLL_OFFSET_VALUE
  // }

  const isCheckAll = () => {
    if (results?.length > 0) {
      if(checkResult?.length === results.length) return true
      if(checkResult?.length < results.length && checkResult?.length > 0) return 'some'
    }
    return false
  }

  return (
    <div className={`new_container_table_scroll ${customClassNameContainer || ''}`}>
      <div className='container_table'>
        {/* {isVisibleHorizontalScroll ? (
          <HorizontalScroll direction='left' onMouseMoveCapture={slideLeft} />
        ) : null} */}
        <div className='container_table--content'>
          <table className='booking-table'>
            <TableHeader
              id='tableBookingHeader'
              colsToShow={colsToShow}
              fieldsColumns={fieldsColumns}
              onChange={onChangeConfigHeader}
              toggleOrder={toggleOrder}
              sortType={sortType}
              active={sortByField}
              isCheckAll={isCheckAll()}
              actionResultCheck={onChangeActionResultCheck}
              results={results}
              originType={originType}
            />
            <TableBody
              id='tableBookingBody'
              colsToShow={colsToShow}
              fieldsColumns={fieldsColumns}
              results={results}
              actionResultCheck={onChangeActionResultCheck}
              checkResult={checkResult}
              detailResult={detailResult}
              totalResult={totalResult}
              originType={originType}
              isAllSelected={isAllSelected}
              toggleSelectedAll={toggleSelectedAll}
            />
          </table>
        </div>
        {/* {isVisibleHorizontalScroll ? (
          <HorizontalScroll direction='right' onMouseMoveCapture={slideRight} />
        ) : null} */}
        <Navigator
          checkResult={checkResult}
          actionOptions={actionOptions}
          onChangeAction={onChangeAction}
          resultActionOptions={resultActionOptions}
          onChangeMassiveAction={onChangeMassiveAction}
          limit={limit}
          totalResult={totalResult}
          numberPage={numberPage}
          isAllSelected={isAllSelected}
          onApplyMassAction={onApplyMassAction}
          loadingMassiveAction={loadingMassiveAction}
          resetMassiveAction={resetMassiveAction}
        />
      </div>
    </div>
  )
}

export default SearchResult
